export default __webpack_public_path__ + "static/media/analytics-anabot-blue.d3da7bd4.svg";